import { useCallback } from 'react';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';
import CurrentUserInterface from '@api/requests/auth/interfaces/CurrentUserInterface.interface';

import { store } from '@app/redux/store';

import { ChangePasswordFormValues } from '@components/forms/changePassword/interfaces';

import { USER_PROFILE_STEPS_ENUM } from '../userProfileViewsFactory';

function useChangePassword({
	setCurrentStep,
}: {
	setCurrentStep(value: USER_PROFILE_STEPS_ENUM): void;
	currentUser: CurrentUserInterface;
}) {
	const { startRequest } = useTriggeredRequest(AccountClientRequests.Users.changePassword);

	const initialValues: ChangePasswordFormValues = {
		old_password: '',
		password: '',
		password_confirmation: '',
	};

	const onSubmit = useCallback(
		async (values: ChangePasswordFormValues) => {
			await startRequest({
				old_password: values.old_password,
				new_password: values.password,
				phone: store.getState().auth.currentUser?.phone || '',
				email: store.getState().auth.currentUser?.email || '',
				branch: store.getState().branchEnvironment.variables.branch_id,
				first_name: store.getState().auth.currentUser?.first_name || '',
				last_name: store.getState().auth.currentUser?.last_name || '',
				mfa_enabled: store.getState().auth.currentUser?.mfa_enabled || false,
			});

			setCurrentStep(USER_PROFILE_STEPS_ENUM.INFO);
		},
		[setCurrentStep, startRequest],
	);

	return {
		initialValues,
		onSubmit,
	};
}

export default useChangePassword;
